import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SocialAwarenessEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
          <Icon name="Heart" size={20} color="var(--color-secondary)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Sosyal Farkındalık İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Toplumsal bilinç oluşturacak mesaj hazırlayın
          </p>
        </div>
      </div>
      <Input
        label="Kampanya Başlığı"
        type="text"
        placeholder="Örn: Yayalara Öncelik Kampanyası"
        value={content?.title || ''}
        onChange={(e) => handleChange('title', e?.target?.value)}
        required
        description="Farkındalık kampanyasının başlığı"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Kampanya Mesajı
          <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-32 md:min-h-40"
          placeholder="Farkındalık mesajınızı yazın..."
          value={content?.message || ''}
          onChange={(e) => handleChange('message', e?.target?.value)}
          required
        />
        <p className="caption text-muted-foreground mt-2">
          Toplumsal sorumluluk ve trafik güvenliği bilinci oluşturacak mesaj
        </p>
      </div>
      <Input
        label="Harekete Geçirici Mesaj"
        type="text"
        placeholder="Örn: Sen de bu kampanyaya destek ol!"
        value={content?.callToAction || ''}
        onChange={(e) => handleChange('callToAction', e?.target?.value)}
        description="Kullanıcıları harekete geçirecek kısa mesaj"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 rounded-lg bg-muted border border-border">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={16} color="var(--color-secondary)" />
            <span className="text-sm font-medium text-foreground">Kampanya Konuları</span>
          </div>
          <ul className="caption text-muted-foreground space-y-1">
            <li>• Yaya güvenliği</li>
            <li>• Çevre dostu sürüş</li>
            <li>• Alkollü sürüş karşıtlığı</li>
            <li>• Hız limitlerine uyum</li>
          </ul>
        </div>

        <div className="p-4 rounded-lg bg-secondary/10 border border-secondary/20">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Users" size={16} color="var(--color-secondary)" />
            <span className="text-sm font-medium text-foreground">Katılım Butonu</span>
          </div>
          <p className="caption text-muted-foreground">
            Kullanıcılar "Katılıyorum" butonu ile kampanyaya destek verebilir
          </p>
        </div>
      </div>
      <div className="p-4 md:p-6 rounded-lg bg-success/10 border border-success/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Etki Oluşturun
            </p>
            <p className="caption text-muted-foreground">
              Sosyal farkındalık mesajları, toplumda olumlu değişim yaratmak için güçlü bir araçtır. Mesajınızın samimi ve etkili olmasına özen gösterin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialAwarenessEditor;